import { httpService } from "utils";
import { DateObject, DateObjectType } from "utils/DateObject";

import { IEReservationIntervalDateGroupDto } from "../Dtos/IEReservationIntervalDateGroupDto";
import { IEReservationIntervalDateGroup } from "../types/IEReservationIntervalDateGroup";

// date będzie w formie MM-YYYY
export const getReservationIntervalList = (
  queueId: string,
  date: DateObjectType | null,
  friendlyUrl: string
): Promise<IEReservationIntervalDateGroup[]> => {
  const formattedDate = date ? date.apiFormat() : null;
  return httpService()
    .get<IEReservationIntervalDateGroupDto[]>(
      `/e-reservation/${friendlyUrl}/queue/${queueId}/intervals?month=${formattedDate}`
    )
    .then((response) => {
      return response.map((group) => {
        return {
          date: DateObject(group.date),
          intervals: group.intervals.map((interval) => {
            return {
              ...interval,
              startDateTime: DateObject(interval.startDateTime),
            };
          }),
        };
      });
    });
};

export const getReservationIntervalListKey = (
  month: number | undefined,
  year: number | undefined
) => ["reservation-interval-list", month, year];
